var render = function render(){var _vm=this,_c=_vm._self._c;return _c('li',{staticClass:"menu-aide"},[_c('router-link',{attrs:{"to":{ name: 'FAQ' },"title":"Trouver de l'aide"}},[_c('svgicon',{staticClass:"help-icon",attrs:{"icon":"help"}}),_vm._v(" "),_c('span',[_vm._v("Aide")])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }